import React, { useState, useEffect, useRef } from "react";
import VideoRecorder from "react-video-recorder";

const VideoRecorderWithCountdown = (props) => {
  const videoRecorderRef = useRef();
  const mimeType = (/Mobi|Android/i.test(navigator.userAgent)) ? "video/mp4" : "video/webm";

    return (
    <VideoRecorder
     ref={videoRecorderRef}
     mimeType={mimeType}
     countdownTime={3000}
     dataAvailableTimeout={2000}
     timeLimit={60000}
     isCameraOn={true}npm 
     showReplayControls={true}
     replayVideoAutoplayAndLoopOff={true}
     useVideoInput={props.useVideoInput}
     isOnInitially={true}
     onRecordingComplete={(video, startedAt, thumbnail, duration, extension) => {
       // Strip codec parameters from mimeType (e.g., "video/webm;codecs=vp9,opus" -> "video/webm")
       // ASP.NET Core rejects Content-Type headers with codec parameters
       const baseMimeType = video.type.split(';')[0];
       const sanitizedVideo = new Blob([video], { type: baseMimeType });

       var upload = {
         video: sanitizedVideo,
         startedAt: startedAt,
         thumbnail: thumbnail,
         duration:duration
       };

       props.videoUploadCompleted(upload);
     }}
    />
  );
};

export default VideoRecorderWithCountdown;
